import React from 'react';
import { Button, Card, CardContent, Typography } from 'ui-kit';
import './AddOnCard.scss';
import { IAddOn } from './features';
import _ from 'lodash';

export interface IAddOnCard {
  addOn: IAddOn;
}

const AddOnCard = ({ addOn }: IAddOnCard) => {
  return (
    <Card className="AddOnCard">
      <CardContent>
        <div className="AddOnContent">
          <div className="AddOnContentCtn">
            <div className="AddOnContentCtnMain">
              <Typography className="AddOnTitle" variant="h6">
                {addOn.planName}
              </Typography>
              <hr className="AddOnDivider"></hr>
              {_.isArray(addOn.planDescription) ? (
                addOn.planDescription.map((description, index) => (
                  <Typography
                    key={index}
                    className="AddOnDescription"
                    variant="body2"
                    style={{ marginBottom: '4px' }}
                  >
                    - {description}
                  </Typography>
                ))
              ) : (
                <Typography className="AddOnDescription" variant="body2">
                  {addOn.planDescription}
                </Typography>
              )}
              <Typography className="AddOnPlanInfo_mobile" variant="caption">
                *{addOn.planInfo}
              </Typography>
            </div>
            <div className="AddOnContentCtnSub">
              <Typography className="AddOnPrice" variant="h4">
                ${addOn.price}
              </Typography>
              <Typography className="AddOnPriceInfo" variant="caption">
                {addOn.priceInfo}*
              </Typography>
              <Typography className="AddOnPlanInfo" variant="caption">
                *{addOn.planInfo}
              </Typography>
            </div>
          </div>
        </div>
        <Button
          className="AddOnButton"
          variant="contained"
          color="textLight"
          size="medium"
          onClick={() => {
            window.open(addOn.link);
          }}
        >
          {addOn.buttonText}
        </Button>
      </CardContent>
    </Card>
  );
};

export default AddOnCard;
